﻿const BASE_WEDDING_THEMES = [
  {
    id: 'classic',
    name: 'Elegante',
    archetype: 'A noiva clássica',
    tagline: 'Serif refinado · Champanhe e marinho',
    description: 'Fontes serifadas Cormorant, tons de champanhe e detalhes dourados. Atemporal, refinado e cheio de presença.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#1a1a2e', accent: '#c9a848', bg: '#fdfbf7', text: '#2d2d2d' },
    palette: ['#fdfbf7', '#1a1a2e', '#c9a848'],
    coverImage: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=1200&q=80',
    previewImage: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=400&q=80',
  },
  {
    id: 'romantic',
    name: 'Romântico',
    archetype: 'A noiva apaixonada',
    tagline: 'Bodoni italic · Rosa e champanhe',
    description: 'Bodoni Moda em itálico, rosa suave e branco. Elegante, floral e transbordante de emoção.',
    font: { heading: "'Bodoni Moda', 'Playfair Display', serif", body: "'Dancing Script', cursive", label: 'Bodoni Moda' },
    colors: { primary: '#9d174d', accent: '#f9a8d4', bg: '#fff0f5', text: '#6b1d3b' },
    palette: ['#fff0f5', '#9d174d', '#f9a8d4'],
    coverImage: 'https://images.unsplash.com/photo-1537633552985-df8429e8048b?w=1200&q=80',
    previewImage: 'https://images.unsplash.com/photo-1537633552985-df8429e8048b?w=400&q=80',
  },
  {
    id: 'minimal',
    name: 'Minimalista',
    archetype: 'A noiva moderna',
    tagline: 'Sans extrabold · Preto e branco puro',
    description: 'Plus Jakarta Sans em peso máximo. Geometria, silêncio e contraste absoluto. Poder sem ornamentos.',
    font: { heading: "'Plus Jakarta Sans', 'Inter', sans-serif", body: "'Inter', system-ui, sans-serif", label: 'Plus Jakarta Sans' },
    colors: { primary: '#0f0f0f', accent: '#525252', bg: '#ffffff', text: '#1a1a1a' },
    palette: ['#ffffff', '#0f0f0f', '#525252'],
    coverImage: 'https://images.unsplash.com/photo-1606800052052-a08af7148866?w=1200&q=80',
    previewImage: 'https://images.unsplash.com/photo-1606800052052-a08af7148866?w=400&q=80',
  },
  {
    id: 'cute',
    name: 'Delicada',
    archetype: 'A noiva fofa',
    tagline: 'DM Serif italic · Lavanda e rosa pastel',
    description: 'DM Serif Display em itálico, lavanda e rosa bebê. Leve, encantadora e cheia de personalidade.',
    font: { heading: "'DM Serif Display', Georgia, serif", body: "'Dancing Script', cursive", label: 'DM Serif Display' },
    colors: { primary: '#7c3aed', accent: '#e879f9', bg: '#fdf4ff', text: '#4c1d95' },
    palette: ['#fdf4ff', '#7c3aed', '#e879f9'],
    coverImage: 'https://images.unsplash.com/photo-1583939003579-730e3918a45a?w=1200&q=80',
    previewImage: 'https://images.unsplash.com/photo-1583939003579-730e3918a45a?w=400&q=80',
  },
  {
    id: 'boho',
    name: 'Boho',
    archetype: 'A noiva livre',
    tagline: 'Fraunces orgânico · Terracota e sálvia',
    description: 'Fraunces com alma rústica, terracota e verde sálvia. Natural, orgânico e com espírito livre.',
    font: { heading: "'Fraunces', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Fraunces' },
    colors: { primary: '#7c4a2d', accent: '#e07b47', bg: '#fdf6ee', text: '#4a3728' },
    palette: ['#fdf6ee', '#7c4a2d', '#e07b47'],
    coverImage: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=1200&q=80',
    previewImage: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=400&q=80',
  },
  {
    id: 'nature',
    name: 'Natureza',
    archetype: 'Noivos conectados com a natureza',
    tagline: 'Cormorant botânico · Verdes e folhagens',
    description: 'Cormorant Garamond em itálico, paleta esverdeada e detalhes botânicos. Fresco, sereno e vivo.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#1f4d3a', accent: '#66a182', bg: '#f3f9f4', text: '#234232' },
    palette: ['#f3f9f4', '#1f4d3a', '#66a182'],
    coverImage: 'https://images.unsplash.com/photo-1470115636492-6d2b56f9146d?w=1200&q=80',
    previewImage: 'https://images.unsplash.com/photo-1470115636492-6d2b56f9146d?w=400&q=80',
  },
  {
    id: 'floral-garden',
    name: 'Jardim Floral',
    archetype: 'Noivos delicados e românticos',
    tagline: 'Bodoni floral · Rosé e verde folha',
    description: 'Bodoni Moda em italic suave, flores aquareladas e tons rosados. Uma tarde encantada no jardim.',
    font: { heading: "'Bodoni Moda', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Bodoni Moda' },
    colors: { primary: '#7a2e45', accent: '#d17b92', bg: '#fff7fa', text: '#5b2e3c' },
    palette: ['#fff7fa', '#7a2e45', '#d17b92'],
    coverImage: 'https://images.unsplash.com/photo-1520854221256-17451cc331bf?w=1200&q=80',
    previewImage: 'https://images.unsplash.com/photo-1520854221256-17451cc331bf?w=400&q=80',
  },
  {
    id: 'rustic-country',
    name: 'Rústico Campestre',
    archetype: 'Noivos de alma natural',
    tagline: 'Fraunces campestre · Terracota e oliva',
    description: 'Fraunces com textura campestre, tons terrosos e folhagens. Aconchegante, autêntico e cheio de história.',
    font: { heading: "'Fraunces', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Fraunces' },
    colors: { primary: '#6b442e', accent: '#9a7b4f', bg: '#f9f3ec', text: '#4a3426' },
    palette: ['#f9f3ec', '#6b442e', '#9a7b4f'],
    coverImage: 'https://images.unsplash.com/photo-1478145046317-39f10e56b5e9?w=1200&q=80',
    previewImage: 'https://images.unsplash.com/photo-1478145046317-39f10e56b5e9?w=400&q=80',
  },
  {
    id: 'clean-white',
    name: 'Clean Branco',
    archetype: 'Noivos minimalistas',
    tagline: 'DM Serif limpo · Branco e dourado suave',
    description: 'DM Serif Display com muito respiro, linhas finas e sofisticação discreta. Elegância pelo silêncio.',
    font: { heading: "'DM Serif Display', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'DM Serif Display' },
    colors: { primary: '#2b2b2b', accent: '#c8a96b', bg: '#ffffff', text: '#3d3d3d' },
    palette: ['#ffffff', '#2b2b2b', '#c8a96b'],
    coverImage: 'https://images.unsplash.com/photo-1529636798458-92182e662485?w=1200&q=80',
    previewImage: 'https://images.unsplash.com/photo-1529636798458-92182e662485?w=400&q=80',
  },
  {
    id: 'starlight-night',
    name: 'Noturno Estrelado',
    archetype: 'Noivos com vibe noturna',
    tagline: 'Cormorant etéreo · Azul profundo e prata',
    description: 'Cormorant Garamond em itálico ultralight. Noite profunda, estrelas de prata. Mágico e imersivo.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#0d1b3d', accent: '#b5c7ff', bg: '#0a1026', text: '#e9edff' },
    palette: ['#0a1026', '#0d1b3d', '#b5c7ff'],
    coverImage: 'https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=1200&q=80',
    previewImage: 'https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=400&q=80',
  },
  {
    id: 'tropical-botanic',
    name: 'Tropical Botânico',
    archetype: 'Noivos vibrantes',
    tagline: 'Fraunces tropical · Verde e coral',
    description: 'Fraunces com energia tropical, folhagens vivas e coral vibrante. Destination wedding com alma.',
    font: { heading: "'Fraunces', Georgia, serif", body: "'Plus Jakarta Sans', 'Inter', sans-serif", label: 'Fraunces' },
    colors: { primary: '#0f5132', accent: '#ff7f50', bg: '#f2fff8', text: '#1d4f38' },
    palette: ['#f2fff8', '#0f5132', '#ff7f50'],
    coverImage: 'https://images.unsplash.com/photo-1465101178521-c1a9136a3b99?w=1200&q=80',
    previewImage: 'https://images.unsplash.com/photo-1465101178521-c1a9136a3b99?w=400&q=80',
  },
  {
    id: 'mediterranean',
    name: 'Mediterrâneo',
    archetype: 'Noivos praianos clássicos',
    tagline: 'Cormorant costeiro · Cobalto e areia',
    description: 'Cormorant Garamond com azul mediterrâneo, branco cal e areia dourada. Sol, mar e eternidade.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#0a4a8a', accent: '#d9b16f', bg: '#f7fbff', text: '#123b63' },
    palette: ['#f7fbff', '#0a4a8a', '#d9b16f'],
    coverImage: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&q=80',
    previewImage: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&q=80',
  },
  {
    id: 'vintage-classic',
    name: 'Vintage Clássico',
    archetype: 'Noivos tradicionais',
    tagline: 'Bodoni nostálgico · Sépia e vinho',
    description: 'Bodoni Moda com textura vintage e sépia. Nostalgia refinada, elegância de outra época.',
    font: { heading: "'Bodoni Moda', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Bodoni Moda' },
    colors: { primary: '#5a2f2f', accent: '#a86b55', bg: '#f8f1e7', text: '#4d3b32' },
    palette: ['#f8f1e7', '#5a2f2f', '#a86b55'],
    coverImage: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=1200&q=80',
    previewImage: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=400&q=80',
  },
  {
    id: 'mono-editorial',
    name: 'Editorial Monocromático',
    archetype: 'Noivos contemporâneos',
    tagline: 'Jakarta extrabold · P&B com acento',
    description: 'Plus Jakarta Sans em 800. Contraste absoluto, grid editorial e tipografia de presença máxima.',
    font: { heading: "'Plus Jakarta Sans', 'Inter', sans-serif", body: "'Inter', system-ui, sans-serif", label: 'Plus Jakarta Sans' },
    colors: { primary: '#101010', accent: '#2e7d32', bg: '#f5f5f5', text: '#181818' },
    palette: ['#f5f5f5', '#101010', '#2e7d32'],
    coverImage: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=1200&q=80',
    previewImage: 'https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=400&q=80',
  },
  {
    id: 'luxury',
    name: 'Luxo',
    archetype: 'A noiva deslumbrante',
    tagline: 'Bodoni dourado · Ouro sobre preto absoluto',
    description: 'Bodoni Moda em itálico sobre fundo escuro profundo, dourado champanhe. Luxo, drama e máxima sofisticação.',
    font: { heading: "'Bodoni Moda', Georgia, serif", body: "'Cormorant Garamond', Georgia, serif", label: 'Bodoni Moda' },
    colors: { primary: '#0d0d0d', accent: '#c9a227', bg: '#0a0a0a', text: '#f5e6c8' },
    palette: ['#0a0a0a', '#c9a227', '#f5e6c8'],
    coverImage: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=1200&q=80',
    previewImage: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=400&q=80',
  },
  {
    id: 'urban',
    name: 'Moderno',
    archetype: 'A noiva urbana',
    tagline: 'Jakarta bold · Chumbo e rose gold',
    description: 'Plus Jakarta Sans em peso máximo, chumbo escuro e rose gold. Ousado, urbano e marcante.',
    font: { heading: "'Plus Jakarta Sans', 'Inter', sans-serif", body: "'Inter', system-ui, sans-serif", label: 'Plus Jakarta Sans' },
    colors: { primary: '#111827', accent: '#e879a0', bg: '#1f2937', text: '#f9fafb' },
    palette: ['#1f2937', '#e879a0', '#f9fafb'],
    coverImage: 'https://images.unsplash.com/photo-1517411032315-54ef2cb783bb?w=1200&q=80',
    previewImage: 'https://images.unsplash.com/photo-1517411032315-54ef2cb783bb?w=400&q=80',
  },
  {
    id: 'beach',
    name: 'Praia',
    archetype: 'A noiva tropical',
    tagline: 'Cormorant costeiro · Azul oceano e coral',
    description: 'Cormorant Garamond em itálico, azul mar e coral vibrante. Leve, arejado e cheio de luz solar.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Plus Jakarta Sans', 'Inter', sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#0077b6', accent: '#f77f00', bg: '#f0f8ff', text: '#023e8a' },
    palette: ['#f0f8ff', '#0077b6', '#f77f00'],
    coverImage: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&q=80',
    previewImage: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&q=80',
  },
  {
    id: 'editorial',
    name: 'Editorial',
    archetype: 'A noiva contemporânea',
    tagline: 'Jakarta extrabold · Vermelho editorial e cinza',
    description: 'Plus Jakarta Sans 800 uppercase, vermelho vibrante e cinza quente. Arte, atitude e composição de revista.',
    font: { heading: "'Plus Jakarta Sans', 'Inter', sans-serif", body: "'Inter', system-ui, sans-serif", label: 'Plus Jakarta Sans' },
    colors: { primary: '#1a1a1a', accent: '#e63946', bg: '#f8f9fa', text: '#212529' },
    palette: ['#f8f9fa', '#1a1a1a', '#e63946'],
    coverImage: 'https://images.unsplash.com/photo-1550005809-91ad75fb315f?w=1200&q=80',
    previewImage: 'https://images.unsplash.com/photo-1550005809-91ad75fb315f?w=400&q=80',
  },

  // ─── TEMAS NOVA GERAÇÃO (com hero.image em alta resolução) ───────────
  // Estes temas usam um `hero` próprio: a página pública renderiza a
  // imagem completa como banner, com overlay degradê e os textos (nomes,
  // data, contador) sobrepostos. É a abordagem do iCasei aplicada com
  // imagens de alta qualidade. As URLs abaixo são placeholders (Unsplash)
  // e devem ser substituídas por gerações IA quando a curadoria começar.
  {
    id: 'orquidea-tropical',
    name: 'Orquídea Tropical',
    archetype: 'A noiva botânica',
    tagline: 'Cormorant · Verde profundo e rosa orquídea',
    description: 'Folhagem botânica densa em fundo verde-escuro, orquídeas pink em destaque. Tropical com elegância.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#1f3a2e', accent: '#d946a8', bg: '#f5f3ef', text: '#1f3a2e' },
    palette: ['#1f3a2e', '#d946a8', '#f5f3ef'],
    paletteNames: ['green', 'pink', 'cream'],
    vibe: ['tropical', 'botânico', 'romântico'],
    hero: {
      image: '/images/themes/orquidea-tropical.png',
      overlay: 'linear-gradient(180deg, rgba(15,30,25,0.15) 0%, rgba(15,30,25,0.55) 100%)',
      textColor: '#ffffff',
      textAlign: 'center',
      textPosition: 'middle',
    },
    coverImage: '/images/themes/orquidea-tropical.png',
    previewImage: '/images/themes/orquidea-tropical.png',
  },
  {
    id: 'sunset-boho',
    name: 'Sunset Boho',
    archetype: 'A noiva nômade',
    tagline: 'Cormorant italic · Pôr do sol em pêssego e areia',
    description: 'Pôr do sol em tons de pêssego, areia e ocre. Atmosfera quente e leve, perfeita pra casamentos ao ar livre.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#7a3e1a', accent: '#e89a5a', bg: '#fbf3ea', text: '#3d2410' },
    palette: ['#fbf3ea', '#e89a5a', '#7a3e1a'],
    paletteNames: ['peach', 'amber', 'sand'],
    vibe: ['boho', 'rústico', 'praia'],
    hero: {
      image: '/images/themes/sunset-boho.png',
      overlay: 'linear-gradient(180deg, rgba(0,0,0,0.10) 0%, rgba(122,62,26,0.50) 100%)',
      textColor: '#ffffff',
      textAlign: 'center',
      textPosition: 'middle',
    },
    coverImage: '/images/themes/sunset-boho.png',
    previewImage: '/images/themes/sunset-boho.png',
  },
  {
    id: 'geo-editorial',
    name: 'Geo Editorial',
    archetype: 'A noiva minimalista',
    tagline: 'Plus Jakarta uppercase · Preto e creme',
    description: 'Composição arquitetônica geométrica em preto e creme. Editorial, severo e impactante.',
    font: { heading: "'Plus Jakarta Sans', 'Inter', sans-serif", body: "'Inter', system-ui, sans-serif", label: 'Plus Jakarta Sans' },
    colors: { primary: '#0a0a0a', accent: '#a8a29e', bg: '#f5f3f0', text: '#1a1a1a' },
    palette: ['#f5f3f0', '#0a0a0a', '#a8a29e'],
    paletteNames: ['black', 'cream', 'gray'],
    vibe: ['minimalista', 'moderno', 'editorial'],
    hero: {
      image: '/images/themes/geo-editorial.png',
      overlay: 'linear-gradient(180deg, rgba(0,0,0,0.30) 0%, rgba(0,0,0,0.65) 100%)',
      textColor: '#ffffff',
      textAlign: 'center',
      textPosition: 'middle',
    },
    coverImage: '/images/themes/geo-editorial.png',
    previewImage: '/images/themes/geo-editorial.png',
  },
  {
    id: 'peonia-classica',
    name: 'Peônia Branca Clássica',
    archetype: 'A noiva atemporal',
    tagline: 'Cormorant · Peônias brancas e eucalipto',
    description: 'Peônias brancas e rosas cascateando do topo, eucalipto sage entrelaçado. Romantismo clássico atemporal.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#3d2818', accent: '#9b6444', bg: '#fbf6ef', text: '#2d1c10' },
    palette: ['#fbf6ef', '#3d2818', '#9b6444'],
    paletteNames: ['cream', 'sage', 'gold'],
    vibe: ['clássico', 'romântico', 'atemporal'],
    hero: {
      image: '/images/themes/peonia-classica.png',
      overlay: 'linear-gradient(180deg, rgba(255,250,240,0.05) 0%, rgba(80,40,25,0.20) 100%)',
      textColor: '#3d2818',
      textAlign: 'center',
      textPosition: 'middle',
    },
    coverImage: '/images/themes/peonia-classica.png',
    previewImage: '/images/themes/peonia-classica.png',
  },
  {
    id: 'mediterranea',
    name: 'Lua de Mel Mediterrânea',
    archetype: 'A noiva exploradora',
    tagline: 'Cormorant · Azul Amalfi e oliveira',
    description: 'Mar azul profundo da costa amalfitana, parede branca caiada e silhuetas de ciprestes. Luz mediterrânea de sol alto.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#0e3a5f', accent: '#4a8db5', bg: '#f4f7fb', text: '#0a2540' },
    palette: ['#0e3a5f', '#4a8db5', '#f4f7fb'],
    paletteNames: ['blue', 'navy', 'cream'],
    vibe: ['praia', 'sofisticado', 'viagem'],
    hero: {
      image: '/images/themes/mediterranea.png',
      overlay: 'linear-gradient(180deg, rgba(15,50,90,0.10) 0%, rgba(10,40,80,0.50) 100%)',
      textColor: '#ffffff',
      textAlign: 'center',
      textPosition: 'middle',
    },
    coverImage: '/images/themes/mediterranea.png',
    previewImage: '/images/themes/mediterranea.png',
  },
  {
    id: 'noite-estrelada',
    name: 'Noite Estrelada',
    archetype: 'A noiva sonhadora',
    tagline: 'Cormorant italic · Via Láctea e navy profundo',
    description: 'Via Láctea arqueando o céu, montanhas distantes e brilho de sol no horizonte. Mood celestial cinematográfico.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#1a1a3a', accent: '#a78bfa', bg: '#0a0a1f', text: '#f0e8ff' },
    palette: ['#0a0a1f', '#a78bfa', '#f0e8ff'],
    paletteNames: ['navy', 'purple', 'lavender'],
    vibe: ['celestial', 'cinematográfico', 'noturno'],
    hero: {
      image: '/images/themes/noite-estrelada.png',
      overlay: 'linear-gradient(180deg, rgba(10,10,30,0.20) 0%, rgba(10,10,30,0.55) 100%)',
      textColor: '#ffffff',
      textAlign: 'center',
      textPosition: 'middle',
    },
    coverImage: '/images/themes/noite-estrelada.png',
    previewImage: '/images/themes/noite-estrelada.png',
  },
  {
    id: 'eucalipto-sage',
    name: 'Eucalipto Sage',
    archetype: 'A noiva moderna botânica',
    tagline: 'Plus Jakarta · Eucalipto e ivory',
    description: 'Eucalipto sage e gypsofila cascateando suavemente, fundo creme em linho. Botânico moderno e respiratório.',
    font: { heading: "'Plus Jakarta Sans', 'Inter', sans-serif", body: "'Inter', system-ui, sans-serif", label: 'Plus Jakarta Sans' },
    colors: { primary: '#2d3e2c', accent: '#7a8c69', bg: '#f5f3eb', text: '#1f2a1d' },
    palette: ['#f5f3eb', '#2d3e2c', '#7a8c69'],
    paletteNames: ['sage', 'green', 'cream'],
    vibe: ['minimalista', 'moderno', 'botânico'],
    hero: {
      image: '/images/themes/eucalipto-sage.png',
      overlay: 'linear-gradient(180deg, rgba(245,243,235,0.05) 0%, rgba(120,135,110,0.25) 100%)',
      textColor: '#2d3e2c',
      textAlign: 'center',
      textPosition: 'middle',
    },
    coverImage: '/images/themes/eucalipto-sage.png',
    previewImage: '/images/themes/eucalipto-sage.png',
  },
  {
    id: 'eucalipto-aquarela',
    name: 'Eucalipto Aquarela',
    archetype: 'A noiva moderna botânica',
    tagline: 'Plus Jakarta · Eucalipto em aquarela',
    description: 'Eucalipto e folhagens em aquarela suave sobre fundo creme. Versão pictórica do botânico moderno, com pinceladas orgânicas.',
    font: { heading: "'Plus Jakarta Sans', 'Inter', sans-serif", body: "'Inter', system-ui, sans-serif", label: 'Plus Jakarta Sans' },
    colors: { primary: '#2d3e2c', accent: '#7a8c69', bg: '#f5f3eb', text: '#1f2a1d' },
    palette: ['#f5f3eb', '#2d3e2c', '#7a8c69'],
    paletteNames: ['sage', 'green', 'cream'],
    vibe: ['minimalista', 'moderno', 'botânico'],
    hero: {
      image: '/images/themes/eucalipto-aquarela.png',
      mobileImage: '/images/themes/eucalipto-aquarela-mobile-3.png',
      overlay: 'linear-gradient(180deg, rgba(245,243,235,0.05) 0%, rgba(120,135,110,0.25) 100%)',
      textColor: '#2d3e2c',
      textAlign: 'center',
      textPosition: 'middle',
    },
    coverImage: '/images/themes/eucalipto-aquarela.png',
    previewImage: '/images/themes/eucalipto-aquarela.png',
  },
  {
    id: 'vintage-dourado',
    name: 'Vintage Dourado',
    archetype: 'A noiva literária',
    tagline: 'Cormorant italic · Sépia e velas douradas',
    description: 'Livros antigos, velas, cartas e rosas secas em luz quente. Antiquário, literário, romance de era passada.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#3d2410', accent: '#c9a848', bg: '#f5ecd9', text: '#2a1808' },
    palette: ['#3d2410', '#c9a848', '#f5ecd9'],
    paletteNames: ['gold', 'sand', 'cream'],
    vibe: ['vintage', 'literário', 'romântico'],
    hero: {
      image: '/images/themes/vintage-dourado.png',
      overlay: 'linear-gradient(180deg, rgba(60,35,15,0.20) 0%, rgba(60,35,15,0.50) 100%)',
      textColor: '#ffffff',
      textAlign: 'center',
      textPosition: 'middle',
    },
    coverImage: '/images/themes/vintage-dourado.png',
    previewImage: '/images/themes/vintage-dourado.png',
  },

  // ─── Foto-realistas (segundo lote) ──────────────────────────────────
  {
    id: 'maldivas',
    name: 'Lua de Mel Maldivas',
    archetype: 'A noiva paradisíaca',
    tagline: 'Cormorant · Turquesa e areia branca',
    description: 'Águas cristalinas turquesa, bangalô sobre o mar e palmeira inclinada. Paraíso tropical em alta resolução.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#0a4d6b', accent: '#5fc1d1', bg: '#e8f5f8', text: '#063a52' },
    palette: ['#5fc1d1', '#e8f5f8', '#0a4d6b'],
    paletteNames: ['blue', 'cream', 'sage'],
    vibe: ['praia', 'tropical', 'lua de mel'],
    hero: {
      image: '/images/themes/maldivas.png',
      overlay: 'linear-gradient(180deg, rgba(10,77,107,0.10) 0%, rgba(10,40,70,0.45) 100%)',
      textColor: '#ffffff', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/maldivas.png',
    previewImage: '/images/themes/maldivas.png',
  },
  {
    id: 'inverno-nordico',
    name: 'Inverno Nórdico',
    archetype: 'A noiva escandinava',
    tagline: 'Cormorant · Neve e galhos brancos',
    description: 'Paisagem escandinava nevada ao amanhecer, bétulas com gelo nos galhos e sutil glow rosado no horizonte.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#1f3a5e', accent: '#8aa7c4', bg: '#f0f4f8', text: '#0f1f3a' },
    palette: ['#1f3a5e', '#8aa7c4', '#f0f4f8'],
    paletteNames: ['blue', 'cream', 'gray'],
    vibe: ['inverno', 'minimalista', 'escandinavo'],
    hero: {
      image: '/images/themes/inverno-nordico.png',
      overlay: 'linear-gradient(180deg, rgba(240,244,248,0.05) 0%, rgba(120,140,170,0.25) 100%)',
      textColor: '#1f3a5e', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/inverno-nordico.png',
    previewImage: '/images/themes/inverno-nordico.png',
  },
  {
    id: 'cerejeira-japonesa',
    name: 'Cerejeira Japonesa',
    archetype: 'A noiva sakura',
    tagline: 'Cormorant italic · Rosa cereja e marfim',
    description: 'Ramos delicados de sakura caindo dos cantos, pétalas flutuando, fundo aquarelado em rosa pálido.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#6b2a3e', accent: '#d99cb1', bg: '#fbeef0', text: '#3a1422' },
    palette: ['#d99cb1', '#fbeef0', '#6b2a3e'],
    paletteNames: ['pink', 'cream', 'rose'],
    vibe: ['oriental', 'romântico', 'poético'],
    hero: {
      image: '/images/themes/cerejeira-japonesa.png',
      overlay: 'linear-gradient(180deg, rgba(251,238,240,0.05) 0%, rgba(150,80,100,0.20) 100%)',
      textColor: '#6b2a3e', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/cerejeira-japonesa.png',
    previewImage: '/images/themes/cerejeira-japonesa.png',
  },
  {
    id: 'provence-lavanda',
    name: 'Provence Lavanda',
    archetype: 'A noiva francesa',
    tagline: 'Cormorant · Lavanda e pôr do sol dourado',
    description: 'Campos de lavanda da Provence ao golden hour, hastes em primeiro plano e céu lilás dourado ao fundo.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#4a2c5e', accent: '#a78bca', bg: '#f4ecf7', text: '#2d1a3d' },
    palette: ['#a78bca', '#4a2c5e', '#e8b76a'],
    paletteNames: ['purple', 'lavender', 'gold'],
    vibe: ['rural', 'romântico', 'francês'],
    hero: {
      image: '/images/themes/provence-lavanda.png',
      overlay: 'linear-gradient(180deg, rgba(74,44,94,0.15) 0%, rgba(74,44,94,0.45) 100%)',
      textColor: '#ffffff', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/provence-lavanda.png',
    previewImage: '/images/themes/provence-lavanda.png',
  },
  {
    id: 'gatsby-deco',
    name: 'Gatsby Art Déco',
    archetype: 'A noiva glamour',
    tagline: 'Plus Jakarta · Preto e dourado champagne',
    description: 'Ornamentos Art Déco em ouro champagne, cristais pendentes, leques e padrões geométricos sobre preto profundo.',
    font: { heading: "'Plus Jakarta Sans', 'Inter', sans-serif", body: "'Inter', system-ui, sans-serif", label: 'Plus Jakarta Sans' },
    colors: { primary: '#0a0a0a', accent: '#c9a848', bg: '#0d0a08', text: '#f5e8c8' },
    palette: ['#c9a848', '#0a0a0a', '#0b3a2e'],
    paletteNames: ['gold', 'black', 'green'],
    vibe: ['luxo', 'glamour', 'noturno'],
    hero: {
      image: '/images/themes/gatsby-deco.png',
      overlay: 'linear-gradient(180deg, rgba(0,0,0,0.20) 0%, rgba(0,0,0,0.50) 100%)',
      textColor: '#ffffff', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/gatsby-deco.png',
    previewImage: '/images/themes/gatsby-deco.png',
  },
  {
    id: 'vinicola-toscana',
    name: 'Vinícola Toscana',
    archetype: 'A noiva wine country',
    tagline: 'Cormorant italic · Terracota e oliva',
    description: 'Vinhedo italiano ao golden hour, ciprestes silhuetados, barris de vinho e colinas toscanas ao fundo.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#5e2818', accent: '#c47550', bg: '#f5e9d8', text: '#3a1a08' },
    palette: ['#5e2818', '#c47550', '#7a8c5a'],
    paletteNames: ['amber', 'sage', 'cream'],
    vibe: ['rústico', 'rural', 'italiano'],
    hero: {
      image: '/images/themes/vinicola-toscana.png',
      overlay: 'linear-gradient(180deg, rgba(90,40,20,0.15) 0%, rgba(90,40,20,0.50) 100%)',
      textColor: '#ffffff', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/vinicola-toscana.png',
    previewImage: '/images/themes/vinicola-toscana.png',
  },
  {
    id: 'wabi-sabi',
    name: 'Wabi-Sabi Zen',
    archetype: 'A noiva contemplativa',
    tagline: 'Plus Jakarta · Bambu e papel washi',
    description: 'Bambu silhuetado nas laterais, pedras zen e detalhes orientais sobre fundo de papel washi creme.',
    font: { heading: "'Plus Jakarta Sans', 'Inter', sans-serif", body: "'Inter', system-ui, sans-serif", label: 'Plus Jakarta Sans' },
    colors: { primary: '#2a2620', accent: '#7a6e4a', bg: '#f0ead9', text: '#1a160e' },
    palette: ['#f0ead9', '#2a2620', '#7a6e4a'],
    paletteNames: ['cream', 'black', 'sand'],
    vibe: ['minimalista', 'oriental', 'meditativo'],
    hero: {
      image: '/images/themes/wabi-sabi.png',
      overlay: 'linear-gradient(180deg, rgba(240,234,217,0.05) 0%, rgba(80,70,50,0.25) 100%)',
      textColor: '#2a2620', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/wabi-sabi.png',
    previewImage: '/images/themes/wabi-sabi.png',
  },

  // ─── Artísticos ─────────────────────────────────────────────────────
  {
    id: 'aquarela-floral',
    name: 'Aquarela Floral',
    archetype: 'A noiva pintada',
    tagline: 'Cormorant italic · Aquarela rosa e sage',
    description: 'Pintura em aquarela com peônias rosa, anêmonas e folhas sage, pigmento fluindo organicamente sobre papel.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#7a3a4a', accent: '#d99cb1', bg: '#faf2ea', text: '#3d1a22' },
    palette: ['#d99cb1', '#faf2ea', '#7a8c5a'],
    paletteNames: ['rose', 'sage', 'cream'],
    vibe: ['artístico', 'romântico', 'pintado'],
    hero: {
      image: '/images/themes/aquarela-floral.png',
      overlay: 'linear-gradient(180deg, rgba(250,242,234,0.05) 0%, rgba(160,100,120,0.20) 100%)',
      textColor: '#7a3a4a', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/aquarela-floral.png',
    previewImage: '/images/themes/aquarela-floral.png',
  },
  {
    id: 'sumi-e',
    name: 'Sumi-e Nanquim',
    archetype: 'A noiva zen',
    tagline: 'Plus Jakarta · Tinta nanquim e washi',
    description: 'Pintura sumi-e japonesa: bambu pintado em tinta preta, ramo de ameixeira e selo vermelho sobre papel washi.',
    font: { heading: "'Plus Jakarta Sans', 'Inter', sans-serif", body: "'Inter', system-ui, sans-serif", label: 'Plus Jakarta Sans' },
    colors: { primary: '#1a1a1a', accent: '#b8364c', bg: '#f5efe3', text: '#0a0a0a' },
    palette: ['#1a1a1a', '#f5efe3', '#b8364c'],
    paletteNames: ['black', 'cream', 'red'],
    vibe: ['oriental', 'minimalista', 'artístico'],
    hero: {
      image: '/images/themes/sumi-e.png',
      overlay: 'linear-gradient(180deg, rgba(245,239,227,0.05) 0%, rgba(80,80,80,0.18) 100%)',
      textColor: '#1a1a1a', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/sumi-e.png',
    previewImage: '/images/themes/sumi-e.png',
  },
  {
    id: 'afresco-renascentista',
    name: 'Afresco Renascentista',
    archetype: 'A noiva clássica italiana',
    tagline: 'Cormorant italic · Terracota e ouro envelhecido',
    description: 'Afresco italiano envelhecido com motivos clássicos, putti silhueta, guirlandas em ocre e rosa pálido.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#7a3a1f', accent: '#c9a848', bg: '#f0d8b8', text: '#3a1a08' },
    palette: ['#7a3a1f', '#c9a848', '#f0d8b8'],
    paletteNames: ['amber', 'gold', 'sand'],
    vibe: ['artístico', 'clássico', 'italiano'],
    hero: {
      image: '/images/themes/afresco-renascentista.png',
      overlay: 'linear-gradient(180deg, rgba(120,60,30,0.15) 0%, rgba(80,40,20,0.40) 100%)',
      textColor: '#ffffff', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/afresco-renascentista.png',
    previewImage: '/images/themes/afresco-renascentista.png',
  },
  {
    id: 'vitral-catedral',
    name: 'Vitral Catedral',
    archetype: 'A noiva sacra',
    tagline: 'Cormorant italic · Vidro colorido e luz dourada',
    description: 'Vitral de catedral com padrões florais em cobalto, rubi, esmeralda e dourado, luz raio entrando do centro.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#1a3a6e', accent: '#d4a448', bg: '#1f2a4a', text: '#f5e8c8' },
    palette: ['#1a3a6e', '#d4a448', '#7a1a2a'],
    paletteNames: ['blue', 'gold', 'red'],
    vibe: ['sacro', 'artístico', 'luminoso'],
    hero: {
      image: '/images/themes/vitral-catedral.png',
      overlay: 'linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.45) 100%)',
      textColor: '#ffffff', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/vitral-catedral.png',
    previewImage: '/images/themes/vitral-catedral.png',
  },
  {
    id: 'linha-continua',
    name: 'Linha Contínua',
    archetype: 'A noiva minimalista contemporânea',
    tagline: 'Plus Jakarta · Linha preta única em papel cream',
    description: 'Desenho de uma linha contínua: ramos floridos abstratos em traço preto delicado sobre papel creme.',
    font: { heading: "'Plus Jakarta Sans', 'Inter', sans-serif", body: "'Inter', system-ui, sans-serif", label: 'Plus Jakarta Sans' },
    colors: { primary: '#0a0a0a', accent: '#3d2410', bg: '#f7f2e8', text: '#0a0a0a' },
    palette: ['#0a0a0a', '#f7f2e8', '#3d2410'],
    paletteNames: ['black', 'cream', 'sand'],
    vibe: ['minimalista', 'artístico', 'moderno'],
    hero: {
      image: '/images/themes/linha-continua.png',
      overlay: 'linear-gradient(180deg, rgba(247,242,232,0.05) 0%, rgba(80,70,60,0.18) 100%)',
      textColor: '#0a0a0a', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/linha-continua.png',
    previewImage: '/images/themes/linha-continua.png',
  },
  {
    id: 'art-nouveau',
    name: 'Art Nouveau',
    archetype: 'A noiva Belle Époque',
    tagline: 'Cormorant italic · Curvas Mucha e pastéis',
    description: 'Ornamentação Art Nouveau ao estilo Mucha: lírios estilizados, curvas decorativas em rosa, mint e dourado.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#4a2a4a', accent: '#a87a6a', bg: '#f5ebd9', text: '#2a141e' },
    palette: ['#a87a6a', '#7a9c8a', '#f5ebd9'],
    paletteNames: ['rose', 'sage', 'gold'],
    vibe: ['artístico', 'decorativo', 'romântico'],
    hero: {
      image: '/images/themes/art-nouveau.png',
      overlay: 'linear-gradient(180deg, rgba(245,235,217,0.05) 0%, rgba(120,90,80,0.22) 100%)',
      textColor: '#4a2a4a', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/art-nouveau.png',
    previewImage: '/images/themes/art-nouveau.png',
  },
  {
    id: 'mosaico-bizantino',
    name: 'Mosaico Bizantino',
    archetype: 'A noiva sagrada',
    tagline: 'Cormorant · Tessellas douradas e lapis',
    description: 'Mosaico bizantino em ouro luminoso com ornamentos em lapis, esmeralda e rubi, estilo Ravenna.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#3a2a0e', accent: '#d4a448', bg: '#1a1a14', text: '#f5e8c8' },
    palette: ['#d4a448', '#1a3a6e', '#7a1a2a'],
    paletteNames: ['gold', 'blue', 'red'],
    vibe: ['sacro', 'luxo', 'artístico'],
    hero: {
      image: '/images/themes/mosaico-bizantino.png',
      overlay: 'linear-gradient(180deg, rgba(0,0,0,0.15) 0%, rgba(0,0,0,0.45) 100%)',
      textColor: '#ffffff', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/mosaico-bizantino.png',
    previewImage: '/images/themes/mosaico-bizantino.png',
  },

  // ─── "Surpresas" — temas viral-bridal ───────────────────────────────
  {
    id: 'floresta-encantada',
    name: 'Floresta Encantada',
    archetype: 'A noiva mágica',
    tagline: 'Cormorant italic · Bosque dourado em raios de luz',
    description: 'Floresta primordial ao amanhecer, raios de luz dourada cortando entre árvores antigas e samambaias.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#1f3a1f', accent: '#d4a460', bg: '#1a2a1a', text: '#f0e8d4' },
    palette: ['#1f3a1f', '#d4a460', '#7a8c5a'],
    paletteNames: ['green', 'gold', 'sage'],
    vibe: ['mágico', 'natureza', 'cinematográfico'],
    hero: {
      image: '/images/themes/floresta-encantada.png',
      overlay: 'linear-gradient(180deg, rgba(20,40,20,0.10) 0%, rgba(20,30,20,0.50) 100%)',
      textColor: '#ffffff', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/floresta-encantada.png',
    previewImage: '/images/themes/floresta-encantada.png',
  },
  {
    id: 'aurora-boreal',
    name: 'Aurora Boreal',
    archetype: 'A noiva cósmica',
    tagline: 'Cormorant italic · Auroras verdes e violeta',
    description: 'Aurora boreal em fitas esmeralda e violeta sobre lago congelado refletindo, montanhas escuras nas bordas.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#0a0a2e', accent: '#5fc1a8', bg: '#0a0a1a', text: '#e8e8ff' },
    palette: ['#5fc1a8', '#7a4ad9', '#0a0a2e'],
    paletteNames: ['green', 'purple', 'navy'],
    vibe: ['cósmico', 'noturno', 'aventureiro'],
    hero: {
      image: '/images/themes/aurora-boreal.png',
      overlay: 'linear-gradient(180deg, rgba(10,10,30,0.15) 0%, rgba(10,10,30,0.50) 100%)',
      textColor: '#ffffff', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/aurora-boreal.png',
    previewImage: '/images/themes/aurora-boreal.png',
  },
  {
    id: 'castelo-escoces',
    name: 'Castelo Escocês',
    archetype: 'A noiva highlands',
    tagline: 'Cormorant italic · Urze roxa e névoa',
    description: 'Castelo escocês na névoa do amanhecer, charneca de urze roxa nas bordas, atmosfera Outlander.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#3a2a4a', accent: '#a78bca', bg: '#e8dde4', text: '#1f1428' },
    palette: ['#7a4a8c', '#a78bca', '#7a8c5a'],
    paletteNames: ['purple', 'lavender', 'sage'],
    vibe: ['celta', 'romântico', 'misterioso'],
    hero: {
      image: '/images/themes/castelo-escoces.png',
      overlay: 'linear-gradient(180deg, rgba(60,40,80,0.10) 0%, rgba(60,40,80,0.45) 100%)',
      textColor: '#ffffff', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/castelo-escoces.png',
    previewImage: '/images/themes/castelo-escoces.png',
  },
  {
    id: 'deserto-rosa',
    name: 'Deserto Rosa',
    archetype: 'A noiva nômade',
    tagline: 'Cormorant italic · Dunas rosa e luar',
    description: 'Dunas em pôr do sol marroquino, palmeira inclinada à esquerda, cactos floridos à direita, luar nascendo.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#7a2a3e', accent: '#e8a890', bg: '#f5d4c8', text: '#3a1018' },
    palette: ['#e8a890', '#c47550', '#7a2a3e'],
    paletteNames: ['rose', 'peach', 'amber'],
    vibe: ['exótico', 'romântico', 'nômade'],
    hero: {
      image: '/images/themes/deserto-rosa.png',
      overlay: 'linear-gradient(180deg, rgba(120,60,80,0.10) 0%, rgba(120,60,80,0.40) 100%)',
      textColor: '#ffffff', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/deserto-rosa.png',
    previewImage: '/images/themes/deserto-rosa.png',
  },
  {
    id: 'veneza',
    name: 'Veneza ao Crepúsculo',
    archetype: 'A noiva veneziana',
    tagline: 'Cormorant italic · Canal ao blue hour',
    description: 'Canal veneziano ao crepúsculo, palazzos em terracota desbotado, gôndola e lanternas acesas.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#1a2a5e', accent: '#e8a460', bg: '#1f2a4a', text: '#f5e8d4' },
    palette: ['#1a2a5e', '#e8a460', '#7a4a3e'],
    paletteNames: ['navy', 'amber', 'rose'],
    vibe: ['romântico', 'europeu', 'icônico'],
    hero: {
      image: '/images/themes/veneza.png',
      overlay: 'linear-gradient(180deg, rgba(20,30,80,0.15) 0%, rgba(20,30,80,0.45) 100%)',
      textColor: '#ffffff', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/veneza.png',
    previewImage: '/images/themes/veneza.png',
  },
  {
    id: 'wildflower-meadow',
    name: 'Wildflower Meadow',
    archetype: 'A noiva livre',
    tagline: 'Cormorant italic · Papoulas e margaridas selvagens',
    description: 'Campo de flores silvestres em pleno verão: papoulas vermelhas, margaridas brancas e cornflowers azuis.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#3a4a1f', accent: '#c43a3a', bg: '#f5f0d9', text: '#1f2a0e' },
    palette: ['#c43a3a', '#f5f0d9', '#7a8c5a'],
    paletteNames: ['red', 'cream', 'sage'],
    vibe: ['rústico', 'romântico', 'free-spirit'],
    hero: {
      image: '/images/themes/wildflower-meadow.png',
      overlay: 'linear-gradient(180deg, rgba(245,240,217,0.10) 0%, rgba(120,140,90,0.30) 100%)',
      textColor: '#3a4a1f', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/wildflower-meadow.png',
    previewImage: '/images/themes/wildflower-meadow.png',
  },
  {
    id: 'marmore-madreperola',
    name: 'Mármore & Madrepérola',
    archetype: 'A noiva quiet luxury',
    tagline: 'Plus Jakarta · Carrara e nácar iridescente',
    description: 'Mármore Carrara polido com pérolas, conchas com interior em madrepérola e flores de magnólia.',
    font: { heading: "'Plus Jakarta Sans', 'Inter', sans-serif", body: "'Inter', system-ui, sans-serif", label: 'Plus Jakarta Sans' },
    colors: { primary: '#3a3a3a', accent: '#d4c4a0', bg: '#f5f3ef', text: '#1a1a1a' },
    palette: ['#f5f3ef', '#d4c4a0', '#3a3a3a'],
    paletteNames: ['cream', 'gold', 'gray'],
    vibe: ['luxo', 'sofisticado', 'minimalista'],
    hero: {
      image: '/images/themes/marmore-madreperola.png',
      overlay: 'linear-gradient(180deg, rgba(245,243,239,0.05) 0%, rgba(120,110,90,0.20) 100%)',
      textColor: '#3a3a3a', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/marmore-madreperola.png',
    previewImage: '/images/themes/marmore-madreperola.png',
  },
  {
    id: 'couture-tulle',
    name: 'Couture Tulle',
    archetype: 'A noiva editorial',
    tagline: 'Cormorant italic · Tule esvoaçante em luz dourada',
    description: 'Camadas de tule em marfim e blush flutuando em câmera lenta sobre fundo creme, drama de alta costura.',
    font: { heading: "'Cormorant Garamond', Georgia, serif", body: "'Inter', system-ui, sans-serif", label: 'Cormorant Garamond' },
    colors: { primary: '#7a4a3e', accent: '#d4a878', bg: '#f5e8d8', text: '#3a1a10' },
    palette: ['#d4a878', '#f5e8d8', '#7a4a3e'],
    paletteNames: ['gold', 'cream', 'peach'],
    vibe: ['couture', 'editorial', 'fashion'],
    hero: {
      image: '/images/themes/couture-tulle.png',
      overlay: 'linear-gradient(180deg, rgba(245,232,216,0.05) 0%, rgba(160,110,80,0.25) 100%)',
      textColor: '#7a4a3e', textAlign: 'center', textPosition: 'middle',
    },
    coverImage: '/images/themes/couture-tulle.png',
    previewImage: '/images/themes/couture-tulle.png',
  },
];
const THEME_SYSTEM_META = {
  classic: { category: 'classic', buttonStyle: 'luxury', heroStyle: 'centered', backgroundStyle: 'paper', cardStyle: 'luxury', animationStyle: 'fade', iconStyle: 'outlined', dividerStyle: 'classic', texture: 'linen', borderStyle: 'thin-gold', imageStyle: 'soft-vignette' },
  romantic: { category: 'romantic', buttonStyle: 'soft', heroStyle: 'centered', backgroundStyle: 'gradient', cardStyle: 'soft', animationStyle: 'fade', iconStyle: 'floral', dividerStyle: 'floral', texture: 'petals', borderStyle: 'rounded', imageStyle: 'glow' },
  minimal: { category: 'modern', buttonStyle: 'outline', heroStyle: 'minimal', backgroundStyle: 'solid', cardStyle: 'clean', animationStyle: 'slide', iconStyle: 'minimal', dividerStyle: 'minimal', texture: 'none', borderStyle: 'hairline', imageStyle: 'clean' },
  cute: { category: 'romantic', buttonStyle: 'soft', heroStyle: 'centered', backgroundStyle: 'grain', cardStyle: 'soft', animationStyle: 'scale', iconStyle: 'rounded', dividerStyle: 'sparkles', texture: 'sparkle', borderStyle: 'soft', imageStyle: 'dreamy' },
  boho: { category: 'nature', buttonStyle: 'filled', heroStyle: 'split', backgroundStyle: 'paper', cardStyle: 'editorial', animationStyle: 'slide', iconStyle: 'organic', dividerStyle: 'branch', texture: 'kraft', borderStyle: 'organic', imageStyle: 'warm' },
  nature: { category: 'nature', buttonStyle: 'soft', heroStyle: 'split', backgroundStyle: 'botanical', cardStyle: 'soft', animationStyle: 'slide', iconStyle: 'organic', dividerStyle: 'botanical', texture: 'leaf', borderStyle: 'organic', imageStyle: 'natural' },
  'floral-garden': { category: 'romantic', buttonStyle: 'soft', heroStyle: 'centered', backgroundStyle: 'botanical', cardStyle: 'soft', animationStyle: 'fade', iconStyle: 'floral', dividerStyle: 'floral', texture: 'floral', borderStyle: 'rounded', imageStyle: 'soft-focus' },
  'rustic-country': { category: 'nature', buttonStyle: 'filled', heroStyle: 'split', backgroundStyle: 'paper', cardStyle: 'editorial', animationStyle: 'slide', iconStyle: 'organic', dividerStyle: 'branch', texture: 'wood', borderStyle: 'organic', imageStyle: 'warm' },
  'clean-white': { category: 'classic', buttonStyle: 'outline', heroStyle: 'minimal', backgroundStyle: 'solid', cardStyle: 'clean', animationStyle: 'fade', iconStyle: 'minimal', dividerStyle: 'minimal', texture: 'none', borderStyle: 'hairline', imageStyle: 'clean' },
  'starlight-night': { category: 'luxury', buttonStyle: 'luxury', heroStyle: 'cinematic', backgroundStyle: 'darkLuxury', cardStyle: 'glass', animationStyle: 'cinematic', iconStyle: 'outlined', dividerStyle: 'editorial', texture: 'stars', borderStyle: 'glow', imageStyle: 'cinematic' },
  'tropical-botanic': { category: 'nature', buttonStyle: 'filled', heroStyle: 'split', backgroundStyle: 'botanical', cardStyle: 'soft', animationStyle: 'slide', iconStyle: 'organic', dividerStyle: 'botanical', texture: 'leaf', borderStyle: 'organic', imageStyle: 'vibrant' },
  mediterranean: { category: 'beach', buttonStyle: 'outline', heroStyle: 'split', backgroundStyle: 'gradient', cardStyle: 'editorial', animationStyle: 'slide', iconStyle: 'outlined', dividerStyle: 'waves', texture: 'tiles', borderStyle: 'sunny', imageStyle: 'bright' },
  'vintage-classic': { category: 'classic', buttonStyle: 'filled', heroStyle: 'centered', backgroundStyle: 'paper', cardStyle: 'editorial', animationStyle: 'fade', iconStyle: 'outlined', dividerStyle: 'classic', texture: 'grain', borderStyle: 'vintage', imageStyle: 'matte' },
  'mono-editorial': { category: 'editorial', buttonStyle: 'ghost', heroStyle: 'editorial', backgroundStyle: 'grain', cardStyle: 'editorial', animationStyle: 'slide', iconStyle: 'minimal', dividerStyle: 'geometry', texture: 'newsprint', borderStyle: 'hairline', imageStyle: 'mono' },
  luxury: { category: 'luxury', buttonStyle: 'luxury', heroStyle: 'cinematic', backgroundStyle: 'darkLuxury', cardStyle: 'luxury', animationStyle: 'cinematic', iconStyle: 'outlined', dividerStyle: 'editorial', texture: 'velvet', borderStyle: 'gold', imageStyle: 'cinematic' },
  urban: { category: 'modern', buttonStyle: 'ghost', heroStyle: 'editorial', backgroundStyle: 'grain', cardStyle: 'glass', animationStyle: 'slide', iconStyle: 'minimal', dividerStyle: 'geometry', texture: 'concrete', borderStyle: 'sharp', imageStyle: 'high-contrast' },
  beach: { category: 'beach', buttonStyle: 'filled', heroStyle: 'split', backgroundStyle: 'gradient', cardStyle: 'soft', animationStyle: 'slide', iconStyle: 'outlined', dividerStyle: 'waves', texture: 'sand', borderStyle: 'soft', imageStyle: 'bright' },
  editorial: { category: 'editorial', buttonStyle: 'ghost', heroStyle: 'editorial', backgroundStyle: 'grain', cardStyle: 'editorial', animationStyle: 'cinematic', iconStyle: 'minimal', dividerStyle: 'geometry', texture: 'paper-grain', borderStyle: 'sharp', imageStyle: 'high-contrast' },
  // ─── Nova geração (com hero.image) ──────────────────────────────────
  'orquidea-tropical': { category: 'nature', buttonStyle: 'soft', heroStyle: 'hero-image', backgroundStyle: 'botanical', cardStyle: 'soft', animationStyle: 'fade', iconStyle: 'organic', dividerStyle: 'botanical', texture: 'leaf', borderStyle: 'organic', imageStyle: 'vibrant' },
  'sunset-boho': { category: 'nature', buttonStyle: 'filled', heroStyle: 'hero-image', backgroundStyle: 'gradient', cardStyle: 'soft', animationStyle: 'fade', iconStyle: 'organic', dividerStyle: 'waves', texture: 'sand', borderStyle: 'organic', imageStyle: 'warm' },
  'geo-editorial': { category: 'editorial', buttonStyle: 'ghost', heroStyle: 'hero-image', backgroundStyle: 'grain', cardStyle: 'editorial', animationStyle: 'cinematic', iconStyle: 'minimal', dividerStyle: 'geometry', texture: 'paper-grain', borderStyle: 'sharp', imageStyle: 'high-contrast' },
  'peonia-classica': { category: 'romantic', buttonStyle: 'soft', heroStyle: 'hero-image', backgroundStyle: 'paper', cardStyle: 'soft', animationStyle: 'fade', iconStyle: 'floral', dividerStyle: 'floral', texture: 'petals', borderStyle: 'rounded', imageStyle: 'soft-vignette' },
  'mediterranea': { category: 'beach', buttonStyle: 'outline', heroStyle: 'hero-image', backgroundStyle: 'gradient', cardStyle: 'editorial', animationStyle: 'slide', iconStyle: 'outlined', dividerStyle: 'waves', texture: 'tiles', borderStyle: 'sunny', imageStyle: 'bright' },
  'noite-estrelada': { category: 'luxury', buttonStyle: 'luxury', heroStyle: 'hero-image', backgroundStyle: 'darkLuxury', cardStyle: 'glass', animationStyle: 'cinematic', iconStyle: 'outlined', dividerStyle: 'celestial', texture: 'stars', borderStyle: 'glow', imageStyle: 'cinematic' },
  'eucalipto-sage': { category: 'nature', buttonStyle: 'soft', heroStyle: 'hero-image', backgroundStyle: 'botanical', cardStyle: 'soft', animationStyle: 'fade', iconStyle: 'organic', dividerStyle: 'botanical', texture: 'leaf', borderStyle: 'organic', imageStyle: 'natural' },
  'eucalipto-aquarela': { category: 'nature', buttonStyle: 'soft', heroStyle: 'hero-image', backgroundStyle: 'botanical', cardStyle: 'soft', animationStyle: 'fade', iconStyle: 'organic', dividerStyle: 'botanical', texture: 'leaf', borderStyle: 'organic', imageStyle: 'natural' },
  'vintage-dourado': { category: 'classic', buttonStyle: 'filled', heroStyle: 'hero-image', backgroundStyle: 'paper', cardStyle: 'luxury', animationStyle: 'fade', iconStyle: 'outlined', dividerStyle: 'classic', texture: 'grain', borderStyle: 'vintage', imageStyle: 'matte' },
  // Foto-realistas segundo lote
  'maldivas': { category: 'beach', buttonStyle: 'outline', heroStyle: 'hero-image', backgroundStyle: 'gradient', cardStyle: 'soft', animationStyle: 'fade', iconStyle: 'outlined', dividerStyle: 'waves', texture: 'tiles', borderStyle: 'soft', imageStyle: 'bright' },
  'inverno-nordico': { category: 'modern', buttonStyle: 'outline', heroStyle: 'hero-image', backgroundStyle: 'solid', cardStyle: 'clean', animationStyle: 'fade', iconStyle: 'minimal', dividerStyle: 'minimal', texture: 'none', borderStyle: 'hairline', imageStyle: 'clean' },
  'cerejeira-japonesa': { category: 'romantic', buttonStyle: 'soft', heroStyle: 'hero-image', backgroundStyle: 'gradient', cardStyle: 'soft', animationStyle: 'fade', iconStyle: 'floral', dividerStyle: 'floral', texture: 'petals', borderStyle: 'rounded', imageStyle: 'soft-focus' },
  'provence-lavanda': { category: 'nature', buttonStyle: 'soft', heroStyle: 'hero-image', backgroundStyle: 'gradient', cardStyle: 'soft', animationStyle: 'fade', iconStyle: 'organic', dividerStyle: 'botanical', texture: 'leaf', borderStyle: 'organic', imageStyle: 'warm' },
  'gatsby-deco': { category: 'luxury', buttonStyle: 'luxury', heroStyle: 'hero-image', backgroundStyle: 'darkLuxury', cardStyle: 'luxury', animationStyle: 'cinematic', iconStyle: 'outlined', dividerStyle: 'editorial', texture: 'velvet', borderStyle: 'gold', imageStyle: 'cinematic' },
  'vinicola-toscana': { category: 'nature', buttonStyle: 'filled', heroStyle: 'hero-image', backgroundStyle: 'paper', cardStyle: 'editorial', animationStyle: 'fade', iconStyle: 'organic', dividerStyle: 'branch', texture: 'wood', borderStyle: 'organic', imageStyle: 'warm' },
  'wabi-sabi': { category: 'modern', buttonStyle: 'outline', heroStyle: 'hero-image', backgroundStyle: 'paper', cardStyle: 'clean', animationStyle: 'fade', iconStyle: 'minimal', dividerStyle: 'botanical', texture: 'linen', borderStyle: 'hairline', imageStyle: 'clean' },
  // Artísticos
  'aquarela-floral': { category: 'romantic', buttonStyle: 'soft', heroStyle: 'hero-image', backgroundStyle: 'gradient', cardStyle: 'soft', animationStyle: 'fade', iconStyle: 'floral', dividerStyle: 'floral', texture: 'petals', borderStyle: 'rounded', imageStyle: 'soft-focus' },
  'sumi-e': { category: 'editorial', buttonStyle: 'ghost', heroStyle: 'hero-image', backgroundStyle: 'paper', cardStyle: 'editorial', animationStyle: 'fade', iconStyle: 'minimal', dividerStyle: 'botanical', texture: 'paper-grain', borderStyle: 'hairline', imageStyle: 'mono' },
  'afresco-renascentista': { category: 'classic', buttonStyle: 'luxury', heroStyle: 'hero-image', backgroundStyle: 'paper', cardStyle: 'luxury', animationStyle: 'fade', iconStyle: 'outlined', dividerStyle: 'classic', texture: 'linen', borderStyle: 'thin-gold', imageStyle: 'soft-vignette' },
  'vitral-catedral': { category: 'luxury', buttonStyle: 'luxury', heroStyle: 'hero-image', backgroundStyle: 'darkLuxury', cardStyle: 'glass', animationStyle: 'fade', iconStyle: 'outlined', dividerStyle: 'editorial', texture: 'velvet', borderStyle: 'gold', imageStyle: 'cinematic' },
  'linha-continua': { category: 'modern', buttonStyle: 'outline', heroStyle: 'hero-image', backgroundStyle: 'solid', cardStyle: 'clean', animationStyle: 'slide', iconStyle: 'minimal', dividerStyle: 'minimal', texture: 'none', borderStyle: 'hairline', imageStyle: 'clean' },
  'art-nouveau': { category: 'romantic', buttonStyle: 'soft', heroStyle: 'hero-image', backgroundStyle: 'paper', cardStyle: 'soft', animationStyle: 'fade', iconStyle: 'floral', dividerStyle: 'floral', texture: 'floral', borderStyle: 'rounded', imageStyle: 'matte' },
  'mosaico-bizantino': { category: 'luxury', buttonStyle: 'luxury', heroStyle: 'hero-image', backgroundStyle: 'darkLuxury', cardStyle: 'luxury', animationStyle: 'fade', iconStyle: 'outlined', dividerStyle: 'editorial', texture: 'velvet', borderStyle: 'gold', imageStyle: 'cinematic' },
  // Surpresas
  'floresta-encantada': { category: 'nature', buttonStyle: 'soft', heroStyle: 'hero-image', backgroundStyle: 'botanical', cardStyle: 'soft', animationStyle: 'fade', iconStyle: 'organic', dividerStyle: 'botanical', texture: 'leaf', borderStyle: 'organic', imageStyle: 'cinematic' },
  'aurora-boreal': { category: 'luxury', buttonStyle: 'luxury', heroStyle: 'hero-image', backgroundStyle: 'darkLuxury', cardStyle: 'glass', animationStyle: 'cinematic', iconStyle: 'outlined', dividerStyle: 'celestial', texture: 'stars', borderStyle: 'glow', imageStyle: 'cinematic' },
  'castelo-escoces': { category: 'nature', buttonStyle: 'filled', heroStyle: 'hero-image', backgroundStyle: 'gradient', cardStyle: 'editorial', animationStyle: 'fade', iconStyle: 'organic', dividerStyle: 'botanical', texture: 'kraft', borderStyle: 'organic', imageStyle: 'cinematic' },
  'deserto-rosa': { category: 'nature', buttonStyle: 'soft', heroStyle: 'hero-image', backgroundStyle: 'gradient', cardStyle: 'soft', animationStyle: 'fade', iconStyle: 'organic', dividerStyle: 'waves', texture: 'sand', borderStyle: 'organic', imageStyle: 'warm' },
  'veneza': { category: 'beach', buttonStyle: 'luxury', heroStyle: 'hero-image', backgroundStyle: 'darkLuxury', cardStyle: 'editorial', animationStyle: 'cinematic', iconStyle: 'outlined', dividerStyle: 'editorial', texture: 'velvet', borderStyle: 'sunny', imageStyle: 'cinematic' },
  'wildflower-meadow': { category: 'nature', buttonStyle: 'soft', heroStyle: 'hero-image', backgroundStyle: 'botanical', cardStyle: 'soft', animationStyle: 'fade', iconStyle: 'floral', dividerStyle: 'floral', texture: 'floral', borderStyle: 'organic', imageStyle: 'warm' },
  'marmore-madreperola': { category: 'luxury', buttonStyle: 'outline', heroStyle: 'hero-image', backgroundStyle: 'solid', cardStyle: 'luxury', animationStyle: 'fade', iconStyle: 'minimal', dividerStyle: 'editorial', texture: 'none', borderStyle: 'thin-gold', imageStyle: 'clean' },
  'couture-tulle': { category: 'editorial', buttonStyle: 'ghost', heroStyle: 'hero-image', backgroundStyle: 'gradient', cardStyle: 'editorial', animationStyle: 'cinematic', iconStyle: 'minimal', dividerStyle: 'editorial', texture: 'velvet', borderStyle: 'soft', imageStyle: 'soft-focus' },
};

// Per-theme design system overrides
const THEME_RADIUS_MAP = {
  luxury:         { small: '2px',    medium: '4px',    large: '6px',    button: '2px',    card: '6px'   },
  'mono-editorial': { small: '2px',  medium: '4px',    large: '6px',    button: '4px',    card: '6px'   },
  urban:          { small: '2px',    medium: '4px',    large: '6px',    button: '4px',    card: '6px'   },
  editorial:      { small: '2px',    medium: '4px',    large: '6px',    button: '4px',    card: '6px'   },
  minimal:        { small: '4px',    medium: '6px',    large: '8px',    button: '4px',    card: '8px'   },
  'clean-white':  { small: '0.5rem', medium: '0.75rem', large: '1rem',  button: '2px',    card: '1rem'  },
  romantic:       { small: '1.5rem', medium: '2rem',   large: '2.5rem', button: '999px',  card: '2rem'  },
  'floral-garden':{ small: '1.5rem', medium: '2rem',   large: '2.5rem', button: '999px',  card: '2rem'  },
  cute:           { small: '1.5rem', medium: '2rem',   large: '2.5rem', button: '999px',  card: '2rem'  },
  boho:           { small: '0.5rem', medium: '0.75rem', large: '1rem',  button: '6px',    card: '1rem'  },
  'rustic-country':{ small: '0.5rem', medium: '0.75rem', large: '1rem', button: '6px',    card: '1rem'  },
};

const THEME_SHADOW_MAP = {
  luxury:         { card: '0 20px 56px rgba(0,0,0,0.55)',  elevated: '0 32px 80px rgba(0,0,0,0.70)' },
  'starlight-night': { card: '0 16px 48px rgba(0,0,0,0.50)', elevated: '0 28px 72px rgba(0,0,0,0.65)' },
  urban:          { card: '0 12px 36px rgba(0,0,0,0.40)',  elevated: '0 24px 60px rgba(0,0,0,0.55)' },
  romantic:       { card: '0 8px 32px rgba(157,23,77,0.14)', elevated: '0 16px 56px rgba(157,23,77,0.20)' },
  'floral-garden':{ card: '0 8px 28px rgba(122,46,69,0.12)', elevated: '0 16px 48px rgba(122,46,69,0.18)' },
  classic:        { card: '0 10px 32px rgba(26,26,46,0.12)', elevated: '0 20px 56px rgba(26,26,46,0.18)' },
  minimal:        { card: '0 4px 20px rgba(0,0,0,0.08)',   elevated: '0 12px 40px rgba(0,0,0,0.14)' },
};

const mapThemeToDesignSystem = (theme) => {
  const meta = THEME_SYSTEM_META[theme.id] || THEME_SYSTEM_META.classic;
  const darkThemes = new Set(['luxury', 'urban', 'starlight-night']);
  const surface = darkThemes.has(theme.id) ? '#111827' : '#ffffff';
  const radiusPreset = THEME_RADIUS_MAP[theme.id] || { small: '0.75rem', medium: '1rem', large: '1.75rem', button: '999px', card: '1.75rem' };
  const shadowPreset = THEME_SHADOW_MAP[theme.id] || {
    card: '0 10px 32px rgba(0,0,0,0.12)',
    elevated: '0 20px 56px rgba(0,0,0,0.20)',
  };
  return {
    ...theme,
    category: meta.category,
    // Campos da "nova geracao" — opcionais. Os temas antigos nao tem
    // `hero`, entao a pagina publica cai no render legado (SVG ornamental).
    hero: theme.hero || null,
    paletteNames: Array.isArray(theme.paletteNames) ? theme.paletteNames : [],
    vibe: Array.isArray(theme.vibe) ? theme.vibe : [],
    // Marca temas legados (sem hero.image — usam o arco SVG antigo). Esses
    // ficam ocultos do picker por padrao (UI desinteressante), mas sao
    // preservados no código pra nao quebrar casamentos que ja escolheram.
    legacy: !theme.hero,
    colors: {
      background: theme.colors.bg,
      surface,
      primary: theme.colors.primary,
      secondary: theme.colors.primary,
      accent: theme.colors.accent,
      text: theme.colors.text,
      mutedText: `${theme.colors.text}99`,
      border: `${theme.colors.primary}22`,
      bg: theme.colors.bg,
    },
    fonts: {
      heading: theme.font?.heading || "'Cormorant Garamond', Georgia, serif",
      body: theme.font?.body || "'Inter', system-ui, sans-serif",
    },
    radius: radiusPreset,
    shadows: shadowPreset,
    buttonStyle: meta.buttonStyle,
    heroStyle: meta.heroStyle,
    backgroundStyle: meta.backgroundStyle,
    cardStyle: meta.cardStyle,
    animationStyle: meta.animationStyle,
    texture: meta.texture,
    borderStyle: meta.borderStyle,
    imageStyle: meta.imageStyle,
    iconStyle: meta.iconStyle,
    dividerStyle: meta.dividerStyle,
  };
};

export const WEDDING_THEMES = BASE_WEDDING_THEMES.map(mapThemeToDesignSystem);
export const AI_STYLES = [
  { id: 'default', name: 'Padrão (deixar a IA decidir o estilo)', icon: '✨', description: 'A IA gera no estilo equilibrado de card de presente — sem forçar foto nem ilustração caricata. Recomendado se você está em dúvida.' },
  { id: 'cartoon3d', name: 'Cartoon 3D (desenho estilizado e vibrante)', icon: '🎨', description: 'Cores vivas, formas arredondadas. Desenho animado 3D mais estilizado que cinematográfico.' },
  { id: 'realistic', name: 'Fotorrealista (estilo foto profissional)', icon: '📷', description: 'Estilo de foto realista, iluminação natural, detalhe fotográfico.' },
  { id: 'caricature', name: 'Caricatura (traços marcantes com humor)', icon: '😄', description: 'Sorriso amplo, expressões exageradas com bom gosto, sem perder a identidade.' },
  { id: 'watercolor', name: 'Aquarela (pintura suave e romântica)', icon: '🖌️', description: 'Pinceladas delicadas, paleta pastel, atmosfera artesanal.' },
  { id: 'pixar', name: 'Animação Cinematográfica (estilo Pixar)', icon: '🎬', description: 'Qualidade de filme premium: iluminação cinematográfica, expressões emotivas.' },
  { id: 'anime', name: 'Anime Elegante (estilo japonês delicado)', icon: '🌸', description: 'Traços limpos, paleta refinada, atmosfera afetuosa.' },
  { id: 'editorial', name: 'Ilustração Editorial (estilo de revista)', icon: '✒️', description: 'Composição limpa, traços precisos, ar de capa de revista sofisticada.' },
  { id: 'bw', name: 'Preto e Branco (carvão e nanquim)', icon: '🖤', description: 'Sem cor, contraste forte, atemporal.' },
  { id: 'storybook', name: 'Livro Ilustrado (estilo livro infantil)', icon: '📖', description: 'Nostálgico e encantado, paleta suave, narrativa carinhosa.' },
  { id: 'popart', name: 'Pop Art (cores chapadas e contornos)', icon: '🎯', description: 'Vibe vintage descolada, cores vibrantes, alto contraste.' },
  { id: 'vintage', name: 'Vintage Botânico (gravura antiga, sépia)', icon: '🌿', description: 'Tons sépia e creme, textura delicada, ar retrô refinado.' },
];

export const HUMOR_LEVELS = [
  { id: 'classic', name: 'Clássico (elegante, romântico, atemporal)', description: 'Para casais que preferem o tradicional: refinado, paleta sóbria.' },
  { id: 'cute', name: 'Fofo (amoroso e encantador)', description: 'Doce, kawaii, corações e detalhes carinhosos.' },
  { id: 'funny', name: 'Engraçado (divertido e levinho)', description: 'Humor leve com cenas cômicas, sem ser caricato.' },
  { id: 'absurd', name: 'Absurdo/Chique (inusitado, mas elegante)', description: 'Situação inesperada (ex.: casal tomando café com um pinguim) mas com sofisticação.' },
  { id: 'dreamy', name: 'Sonhador (atmosfera onírica)', description: 'Paleta etérea, sensação de sonho, brilho mágico.' },
  { id: 'festive', name: 'Festivo (energia de festa)', description: 'Confetes, fitas, vivacidade, clima de comemoração.' },
];

export const GIFT_CATEGORIES = [
  { id: 'honeymoon', name: 'Lua de mel', icon: '🌙' },
  { id: 'home', name: 'Casa nova', icon: '🏠' },
  { id: 'experience', name: 'Experiências', icon: '🎈' },
  { id: 'food', name: 'Comida', icon: '🍽️' },
  { id: 'travel', name: 'Viagem', icon: '✈️' },
  { id: 'couple', name: 'Mimos do casal', icon: '💑' },
  { id: 'funny', name: 'Cards engraçados', icon: '😂' },
];

export const CARD_LIBRARY = [
  { id: 'lib1', title: 'Passeio de Gôndola Romântico', description: 'Uma tarde mágica navegando pelos canais de Veneza, com champanhe e música ao vivo.', category: 'honeymoon', suggestedValue: 380, image: '/images/cards/passeio-gondola.jpg', emoji: '✈️' },
  { id: 'lib2', title: 'Jantar Chique Sem Queimar o Arroz', description: 'Experiência gastronômica no melhor restaurante da cidade.', category: 'food', suggestedValue: 280, image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600&q=80', emoji: '🍽️' },
  { id: 'lib3', title: 'Upgrade da Lua de Mel', description: 'Diária extra no hotel mais paradisíaco que existe.', category: 'honeymoon', suggestedValue: 550, image: 'https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?w=600&q=80', emoji: '✈️' },
  { id: 'lib4', title: 'Café da Manhã de Recém-Casados', description: 'Croissants, suco e muito amor na varanda mais gostosa do mundo.', category: 'couple', suggestedValue: 120, image: 'https://images.unsplash.com/photo-1504754524776-8f4f37790ca0?w=600&q=80', emoji: '💑' },
  { id: 'lib5', title: 'Passeio com Cisnes', description: 'Um lago, dois cisnes e um casal apaixonado.', category: 'experience', suggestedValue: 200, image: '/images/cards/passeio-cisnes.jpg', emoji: '🎈' },
  { id: 'lib6', title: 'Kit Sobrevivência Pós-Festa', description: 'Sandálias confortáveis e itens de recuperação para o pós-festa.', category: 'funny', suggestedValue: 90, image: '/images/cards/kit-posfesta.png', emoji: '😂' },
  { id: 'lib7', title: 'Primeira Compra de Mercado', description: 'O ritual sagrado do casal: o primeiro carrinho cheio juntos.', category: 'home', suggestedValue: 300, image: 'https://images.unsplash.com/photo-1542838132-92c53300491e?w=600&q=80', emoji: '🏠' },
  { id: 'lib8', title: 'Sofá dos Sonhos', description: 'O sofá perfeito para maratonar séries juntinhos.', category: 'home', suggestedValue: 420, image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=600&q=80', emoji: '🏠' },
  { id: 'lib9', title: 'Massagem Para Recuperar da Festa', description: 'Spa completo para dois.', category: 'couple', suggestedValue: 250, image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=600&q=80', emoji: '💑' },
  { id: 'lib10', title: 'Diária Extra na Lua de Mel', description: 'Mais um dia no paraíso.', category: 'honeymoon', suggestedValue: 480, image: 'https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=600&q=80', emoji: '✈️' },
  { id: 'lib11', title: 'Piquenique Romântico no Parque', description: 'Cesta com queijos, frutas e vinho para uma tarde a dois ao ar livre.', category: 'experience', suggestedValue: 160, image: 'https://images.unsplash.com/photo-1528715471579-d1bcf0ba5e83?w=600&q=80', emoji: '🎈' },
  { id: 'lib12', title: 'Plantio da Árvore do Amor', description: 'Uma árvore que vai crescer junto com o amor de vocês.', category: 'home', suggestedValue: 80, image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=600&q=80', emoji: '🏠' },
  { id: 'lib13', title: 'Brinde ao Pôr do Sol', description: 'Taças especiais e espumante para celebrar o amor com vista inesquecível.', category: 'couple', suggestedValue: 140, image: '/images/cards/brinde-por-sol.jpg', emoji: '💑' },
  { id: 'lib14', title: 'Noite de Queijos e Vinhos', description: 'Tábua premium para um jantar romântico em casa.', category: 'food', suggestedValue: 220, image: '/images/cards/noite-queijos-vinhos.jpg', emoji: '🍽️' },
  { id: 'lib15', title: 'Kit Cama dos Sonhos', description: 'Jogo de cama macio para noites aconchegantes.', category: 'home', suggestedValue: 260, image: 'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=600&q=80', emoji: '🏠' },
  { id: 'lib16', title: 'Roteiro de Final de Semana', description: 'Uma escapada curta para renovar as energias em casal.', category: 'travel', suggestedValue: 390, image: 'https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=600&q=80', emoji: '🧳' },
  { id: 'lib17', title: 'Jantar à Luz de Velas', description: 'Experiência gastronômica intimista para dois.', category: 'food', suggestedValue: 240, image: '/images/cards/jantar-luz-velas.jpg', emoji: '🍽️' },
  { id: 'lib18', title: 'Kit Café Especial', description: 'Grãos selecionados e acessórios para café da manhã perfeito.', category: 'home', suggestedValue: 130, image: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=600&q=80', emoji: '🏠' },
  { id: 'lib19', title: 'Passeio de Balão', description: 'Uma experiência memorável nas alturas para celebrar o amor.', category: 'experience', suggestedValue: 520, image: 'https://images.unsplash.com/photo-1507608616759-54f48f0af0ee?w=600&q=80', emoji: '🎈' },
  { id: 'lib20', title: 'Almoço de Domingo em Família', description: 'Momento especial para reunir quem vocês amam.', category: 'food', suggestedValue: 180, image: 'https://images.unsplash.com/photo-1528605248644-14dd04022da1?w=600&q=80', emoji: '🍽️' },
  { id: 'lib21', title: 'Jogo de Panelas Premium', description: 'Cozinha completa para novas receitas do casal.', category: 'home', suggestedValue: 470, image: '/images/cards/panelas-premium.jpg', emoji: '🏠' },
  { id: 'lib22', title: 'Trilha com Piquenique', description: 'Natureza, aventura e um lanche especial para dois.', category: 'experience', suggestedValue: 170, image: '/images/cards/trilha-piquenique.jpg', emoji: '🎈' },
  { id: 'lib23', title: 'Cinema em Casa', description: 'Sessão com snacks e conforto para maratonar juntinhos.', category: 'couple', suggestedValue: 110, image: 'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=600&q=80', emoji: '💑' },
  { id: 'lib24', title: 'Aula de Dança para Dois', description: 'Uma experiência divertida para aprender novos passos.', category: 'experience', suggestedValue: 190, image: '/images/cards/aula-danca-dois.jpg', emoji: '🎈' },
  { id: 'lib25', title: 'Kit Banho Relaxante', description: 'Velas, sais e essências para um spa em casa.', category: 'couple', suggestedValue: 150, image: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=600&q=80', emoji: '💑' },
  { id: 'lib26', title: 'Diária em Chalé Romântico', description: 'Uma noite especial em meio à natureza.', category: 'travel', suggestedValue: 610, image: '/images/cards/diaria-chale-romantico.jpg', emoji: '🧳' },
  { id: 'lib27', title: 'Fondue a Dois', description: 'Noite deliciosa com fondue doce e salgado.', category: 'food', suggestedValue: 210, image: '/images/cards/fondue-dois.jpg', emoji: '🍽️' },
  { id: 'lib28', title: 'Kit Decoração da Sala', description: 'Almofadas, mantas e quadros para deixar a casa com a cara do casal.', category: 'home', suggestedValue: 300, image: 'https://images.unsplash.com/photo-1484101403633-562f891dc89a?w=600&q=80', emoji: '🏠' },
  { id: 'lib29', title: 'Passeio de Barco', description: 'Tarde leve e romântica para curtir o mar.', category: 'travel', suggestedValue: 340, image: '/images/cards/passeio-barco.jpg', emoji: '🧳' },
  { id: 'lib30', title: 'Kit Primeira Viagem', description: 'Acessórios essenciais para viagem de casal sem perrengue.', category: 'travel', suggestedValue: 160, image: 'https://images.unsplash.com/photo-1488646953014-85cb44e25828?w=600&q=80', emoji: '🧳' },
];

export const SAAS_PLANS = [
  {
    id: 'basic',
    name: 'Mimo Grátis',
    price: 0,
    commission: 2.99,
    color: 'from-rose-400 to-pink-600',
    features: [
      'Página de casamento personalizada',
      'Presentes ilimitados',
      'Link e URL exclusiva do casal',
      'Pix direto na sua conta (tempo real)',
      'Todos os temas visuais',
      'IA para cards ilustrados',
      'Dashboard com analytics',
      'Link para compartilhamento',
      'Mensagens dos convidados',
      'Suporte por email e WhatsApp',
    ],
    cta: 'Começar Grátis',
  },
];

export const FAQ_ITEMS = [
  {
    q: 'Como funciona a lista de presentes simbólicos?',
    a: 'Os convidados escolhem um card simbólico e o valor vai direto para os noivos via Pix ou cartão.',
  },
  {
    q: 'Como a IA gera as imagens personalizadas?',
    a: 'A IA usa as fotos do casal como referência para criar cards em estilos diferentes.',
  },
  {
    q: 'Os convidados precisam baixar algum app?',
    a: 'Não. A página funciona direto no navegador.',
  },
  {
    q: 'Posso personalizar completamente a página?',
    a: 'Sim. Você escolhe tema, fotos, história e presentes.',
  },
  {
    q: 'Quando e como eu recebo o dinheiro dos presentes?',
    a: 'Via Pix, na hora. Basta ter R$ 100 acumulados para sacar (taxa de R$ 5). Só o primeiro saque passa por uma janela de segurança de 7 dias contra fraude — os seguintes caem em segundos via Pix.',
  },
  {
    q: 'Como funciona a confirmação de presença (RSVP)?',
    a: 'Você escolhe se a lista é aberta (qualquer convidado confirma) ou fechada (só quem você cadastrar). Os convidados confirmam presença e acompanhantes direto na página, sem precisar de app.',
  },
  {
    q: 'Posso trocar o tema da página depois de criar?',
    a: 'Sim, quando quiser. Temos dezenas de temas e você troca à vontade sem perder fotos, textos ou presentes já cadastrados.',
  },
  {
    q: 'A página fica no ar depois do casamento?',
    a: 'Sim. Ela continua ativa enquanto vocês quiserem — não expira sozinha.',
  },
  {
    q: 'Dá para cancelar ou excluir minha conta?',
    a: 'Sim, quando quiser, direto pelas configurações. A exclusão segue a LGPD e remove seus dados da plataforma.',
  },
];

